// ================================
// CUSTOMER SIGNUP
// ================================
import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function CustomerSignup() {
  const [form, setForm]           = useState({ name: '', phone: '', address: '', zip: '', dob: '' });
  const [idPhoto, setIdPhoto]     = useState(null);
  const [selfie, setSelfie]       = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading]     = useState(false);
  const [error, setError]         = useState('');
  const navigate                  = useNavigate();
  const [searchParams]            = useSearchParams();
  const referredBy                = searchParams.get('ref') || '';

  function update(field, val) { setForm(f => ({ ...f, [field]: val })); }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (!idPhoto || !selfie) {
      setError('A photo of your ID and a selfie are both required — this is how we confirm you\'re 21+.');
      return;
    }
    setLoading(true);
    try {
      const data = new FormData();
      Object.entries(form).forEach(([k, v]) => data.append(k, v));
      if (referredBy) data.append('referredBy', referredBy);
      data.append('idPhoto', idPhoto);
      data.append('selfie', selfie);

      const res = await fetch('/api/members/request', { method: 'POST', body: data });
      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(body.error || 'Something went wrong');
      }
      setSubmitted(true);
    } catch (err) {
      setError(err.message || 'Something went wrong. Try again.');
    } finally {
      setLoading(false);
    }
  }

  if (submitted) {
    return (
      <div className="app-shell" style={{
        alignItems: 'center', justifyContent: 'center',
        padding: 40, textAlign: 'center'
      }}>
        <div style={{ fontSize: 52, marginBottom: 16 }}>🚀</div>
        <h2 style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: 28, letterSpacing: 2, marginBottom: 8 }}>
          Request Sent
        </h2>
        <p style={{ fontSize: 13, color: '#3a5a8a', lineHeight: 1.7, marginBottom: 32 }}>
          We'll review your ID and send your Member ID and access link once approved. Stay tuned.
        </p>
        <button className="btn-primary" onClick={() => navigate('/')}>Back to Home</button>
      </div>
    );
  }

  return (
    <div className="app-shell" style={{ padding: '28px' }}>
      <button className="back-btn" onClick={() => navigate('/')}>← Back</button>
      <h2 style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: 30, letterSpacing: 2, marginBottom: 4 }}>
        Request Access
      </h2>
      <p style={{ fontSize: 13, color: '#3a5a8a', marginBottom: 28 }}>
        Members only, 21+ — we verify ID before approving.
      </p>
      <form onSubmit={handleSubmit}>
        <div className="field">
          <label>Full Name</label>
          <input type="text" placeholder="Your name"
            value={form.name} onChange={e => update('name', e.target.value)} required />
        </div>
        <div className="field">
          <label>Phone Number</label>
          <input type="tel" placeholder="+1 (555) 000-0000"
            value={form.phone} onChange={e => update('phone', e.target.value)} required />
        </div>
        <div className="field">
          <label>Delivery Address</label>
          <input type="text" placeholder="Street address"
            value={form.address} onChange={e => update('address', e.target.value)} required />
        </div>
        <div className="field">
          <label>Zip Code</label>
          <input type="text" placeholder="00000"
            value={form.zip} onChange={e => update('zip', e.target.value)} required />
        </div>
        <div className="field">
          <label>Date of Birth</label>
          <input type="date"
            value={form.dob} onChange={e => update('dob', e.target.value)} required />
        </div>

        <div className="field">
          <label>Photo of your ID</label>
          <input type="file" accept="image/*" capture="environment"
            onChange={e => setIdPhoto(e.target.files?.[0] || null)} required />
          <p style={{ fontSize: 11, color: '#3a5a8a', marginTop: 4 }}>Driver's license, state ID, or passport. Used only to confirm your age.</p>
        </div>
        <div className="field">
          <label>Selfie</label>
          <input type="file" accept="image/*" capture="user"
            onChange={e => setSelfie(e.target.files?.[0] || null)} required />
          <p style={{ fontSize: 11, color: '#3a5a8a', marginTop: 4 }}>So we can confirm the ID is actually you.</p>
        </div>

        {error && <p style={{ fontSize: 13, color: '#c0101a', marginTop: 8 }}>{error}</p>}

        <div style={{ marginTop: 20 }}>
          <button className="btn-primary" type="submit" disabled={loading}>
            {loading ? 'Submitting...' : 'Submit Request'}
          </button>
          <p style={{ textAlign: 'center', fontSize: 12, color: '#3a5a8a', marginTop: 14 }}>
            Already a member?{' '}
            <span style={{ color: '#1e6bff', cursor: 'pointer' }}
              onClick={() => navigate('/login')}>Sign in</span>
          </p>
        </div>
      </form>
    </div>
  );
}
